import { debouncify } from './debouncify';
export function debounce(delayMs) {
    return (target, propertyName, descriptor) => {
        if (descriptor.value) {
            descriptor.value = debouncify(descriptor.value, delayMs);
            return descriptor;
        }
        throw new Error('@debounce is applicable only on a methods.');
    };
}
